document.addEventListener('DOMContentLoaded', () => {
  const links = document.querySelectorAll('a[href^="/pages/store-locator-store-details"]')

  links.forEach(link => {
    link.addEventListener('click', scrollToSection)
  })

  function scrollToSection (e) {
    e.preventDefault()
    const targetId = this.getAttribute('href').split('#')[1]
    const targetElement = document.getElementById(targetId)

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
      })

      // Update URL with anchor
      if (history.pushState) {
        history.pushState(null, null, `/pages/store-locator-store-details#${targetId}`)
      } else {
        window.location.hash = `#${targetId}`
      }
    }
  }
})
